import { DRPHeader } from "@inputs/date/DateRangePicker/headers";
import { useDRDPHeader } from "./logics";

export const DRDPHeader = () => {
  const props = useDRDPHeader();

  return <DRPHeader {...props} placeholder="dd/mm/aaaa" mask="00/00/0000" labelStart="Du" labelEnd="Au" />;
};
